var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authoritative-pdf-review2"},[_c('pdf-view',_vm._g(_vm._b({ref:"preview"},'pdf-view',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }